import { z } from "zod"

export const EmailSchema = z.object({
  id: z.number(),
  custom_id: z.string(),
  subject: z.string().nullable(),
  body: z.string().nullable(),
  project_id: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
  style: z.string(),
})

export type Email = z.infer<typeof EmailSchema>
